


























































import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { UpdateEvalSettingSimpleRequest } from '@/models/evalSetting/eval-setting-simple';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { evalSettingDetailModule } from '@/store/modules/frames/eval-setting-detail.module';
import { CompetencyType } from '@/constants/competencyType.enum';
import { GEnum } from '@/constants/enum.defination';
import { AllEvalSetting } from '@/models/evalSetting/all-eval-setting';

@Component({
  name: 'GExsmDetailFeedbackReportModal',
  computed: {},
  methods: {},
})
export default class GExsmDetailFeedbackReportModal extends Mixins(GPageBase) {
  showSelectModal: boolean = false;
  step: number = 0;
  reportTypes: GEnum.PersonalReportDisplayType[] = evalSettingModule.reportSelectItems;
  @Prop({ default: false }) value: boolean;
  @Prop({ default: false }) isAllCompleated: boolean;
  evalSetting: EvalSetting = evalSettingModule.evalSettingDetail;
  tmpIsForceReport: boolean = false;
  tmpIsFixed: boolean = false;

  @Watch('value')
  openModal(value: boolean) {
    if (this.isAllCompleated) {
      this.tmpIsForceReport = false;
      this.tmpIsFixed = true;
    }
    this.isAllCompleated ? this.openThirdModal() : this.openFirstModal();
    this.showSelectModal = value;
  }

  get isFooter(): boolean {
    return this.step !== 2;
  }

  handleCancel() {
    this.clear();
  }

  clear() {
    this.step = 0;
    this.$emit('input', false);
    this.$emit('showSelectModal', false);
  }

  handleOnlyCompleate() {
    // 完了した生徒のみ、フィードバックレポート生成
    this.tmpIsForceReport = false;
    this.openThirdModal();
  }

  handleAllStudent() {
    // 未完了の生徒も含める、レポート強制生成
    this.tmpIsForceReport = true;
    this.openThirdModal();
  }

  handleIsFixedValue(value: boolean) {
    this.tmpIsFixed = value;
    this.openSecondModal();
  }

  openFirstModal() {
    this.step = 0;
  }

  openSecondModal() {
    this.step = 1;
  }

  openThirdModal() {
    this.step = 2;
  }

  // 表示文字列を取得
  conptencyTypeReport(reportLink: GEnum.PersonalReportDisplayType): string {
    return CompetencyType.personalReportType(reportLink);
  }

  handleGenerateFeedbackReport() {
    // レポート強制生成またはフィードバックレポート作成処理を呼び出す。
    evalSettingDetailModule.setIsForceReport(this.tmpIsForceReport);
    evalSettingDetailModule.setIsFixed(this.tmpIsFixed);
    this.$emit('handleIsFixedValue');
    // 処理完了時に初期化する
    this.clear();
  }

  handleUpdateReportLink(evalSetting: EvalSetting) {
    const updateEvalSettingSimpleRequest: UpdateEvalSettingSimpleRequest = {
      evalSettingID: evalSetting.evalSettingID,
      title: evalSetting.title,
      startTime: evalSetting.startTime,
      deadline: evalSetting.deadline,
    };
    evalSettingModule.setSelectedItem(evalSetting.selectedReportLink);
    evalSettingModule.updateReportLink(updateEvalSettingSimpleRequest);

    var newSelectValue = CompetencyType.personalReportType(evalSetting.selectedReportLink);
    var oldSelectValue = evalSetting.isPostingReportEnabled
      ? CompetencyType.personalReportType(evalSetting.personalReportDisplayType)
      : CompetencyType.personalReportType(GEnum.PersonalReportDisplayType.NoShow);

    // 成功時のメッセージ
    this.showNotice(GEnum.MessageType.Success, this.$t('UPDATE_REPORT_LINK').toString(), this.$t('EVAL_COURSE_NAME').toString() + `:${evalSetting.title}<br/>` + this.$t('BEFORE_EDIT').toString() + ` : ${oldSelectValue}<br/>` + this.$t('AFTER_EDIT').toString() + ` : ${newSelectValue}`);

    // evalSetting を更新する
    evalSetting.personalReportDisplayType = evalSettingModule.reportDisplayType;
    evalSetting.isPostingReportEnabled = evalSettingModule.reportEnabled;
  }
}
